import {COLORS, SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {RecommendationsSkeleton} from '../Recommendations/Recommendations.skeleton';

export const BasketFlyoutContentSkeleton = () => {
  return (
    <div>
      <div>
        <ButtonSkeletonWrapper>
          <ButtonSkeleton />
          <ButtonSkeleton />
        </ButtonSkeletonWrapper>
      </div>
      <RecommendationsSkeleton />
    </div>
  );
};

const ButtonSkeleton = styled(SkeletonBlock)`
  width: 100%;
  height: 45px;
`;

const ButtonSkeletonWrapper = styled.div`
  display: flex;
  gap: 1.25rem;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid ${COLORS.Grey3};
`;
